import { __assign } from 'tslib';
import { colorGrayDusk } from '@hse-design/tokens';
import clsx from 'clsx';
import Vue from 'vue';
import __vue_component__ from './HseHeaderIcon.vue.js';

/**
 * Кнопка гамбургер меню
 */
var script = Vue.extend({
    name: 'HseHeaderHamburger',
    functional: true,
    props: {
        /**
         * Открытое состояние
         */
        isOpen: {
            type: Boolean,
            default: false
        }
    },
    render: function (h, ctx) {
        var _a, _b;
        var data = ctx.data, props = ctx.props, listeners = ctx.listeners;
        return h(__vue_component__, __assign(__assign({}, data), { props: __assign({ component: 'button' }, data.attrs), staticClass: clsx('hse-HeaderHamburger', {
                'hse-HeaderHamburger_isOpen': props.isOpen
            }, data.staticClass), on: listeners }), [
            h('span', { staticClass: 'hse-HeaderHamburger__bars', style: { color: (_b = (_a = data.attrs) === null || _a === void 0 ? void 0 : _a.iconColor) !== null && _b !== void 0 ? _b : colorGrayDusk } }, [
                h('span', { staticClass: 'hse-HeaderHamburger__bar' }),
                h('span', { staticClass: 'hse-HeaderHamburger__bar' }),
                h('span', { staticClass: 'hse-HeaderHamburger__bar' }),
                h('span', { staticClass: 'hse-HeaderHamburger__bar hse-HeaderHamburger__bar_cross' }),
                h('span', { staticClass: 'hse-HeaderHamburger__bar hse-HeaderHamburger__bar_cross' })
            ])
        ]);
    }
});

export default script;
